import { takeLatest, call, select, put, delay } from "redux-saga/effects"
import { hideAlert, showAlertAction } from "../actions/alertActions"
import {
	extractFileRequestClear,
	extractFileRequestFailed,
	extractFileRequestSuccess,
	uploadFileRequestClear,
	uploadFileRequestFailed,
	uploadFileRequestSuccess,
	kbMakingTriggerRequestSuccess,
	kbMakingTriggerRequestFailed,
	kbMakingTriggerRequestClear,
	PiiExtractTriggerRequestSuccess,
	PiiExtractTriggerRequestFailed,
	PiiExtractTriggerRequestClear,
	getUploadFileSummarySuccess,
	getUploadFileSummaryFailed,
	getUploadFileSummaryClear,
	deleteCaseRequestSuccess,
	deleteCaseRequestFailed,
	deleteCaseRequestClear,
	getCaseDetailsRequest,
	RevertPiiExtractRequestFailed,
	RevertPiiExtractRequestSuccess,
	RevertPiiExtractRequestClear,
	RevertTextExtractRequestFailed,
	RevertTextExtractRequestSuccess,
	RevertTextExtractRequestClear,
	changeCaseModeRequestSuccess,
	changeCaseModeRequestFailed,
	changeCaseModeRequestClear,
	postBifrostJobRequestSuccess,
	postBifrostJobRequestFailed,
	postBifrostJobRequestReset,
} from "../actions/bifrostActions"
import {
	extractFileService,
	uploadFileService,
	getUploadFileSummaryService,
	kbMakingService,
	deletCaseService,
	PiiExtractService,
	RevertPiiExtractService,
	RevertTextExtractService,
	ChangeCaseModeService,
	bifrostJobService,
} from "../services/bifrostServices"
import { CLIENT_SIDE_MESSAGES as Messages, clearLocalStorage } from "../utils"
import { clearMultibase } from "../actions/multiAiBase"
import { logoutUser } from "../actions/userActions"
import {
	DELETE_CASE_REQUEST,
	EXTRACT_FILE_REQUEST,
	GET_UPLOAD_FILE_SUMMARY_REQUEST,
	KB_MAKING_TRIGGER_REQUEST,
	UPLOAD_FILE_REQUEST,
	PII_EXTRACT_TRIGGER_REQUEST,
	REVERT_PII_EXTRACT_REQUEST,
	REVERT_TEXT_EXTRACT_REQUEST,
	CHANGE_CASE_MODE_REQUEST,
	POST_BIFROST_JOB_REQUEST,
} from "../types"
import axiosClient from "axios"
import { setNotification } from "../actions/notificationActions"

function* uploadFileSaga(action) {
	try {
		const { name, refreshCasePage, ...data } = action.payload
		const result = yield call(uploadFileService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(uploadFileRequestSuccess(result.data.bifrost_job)) //update store
			yield put(
				setNotification({
					data: `${name} ${Messages.BIFROST_FILE_UPLOAD_SUCCESS_MESSAGE}`,
					severity: "info",
					color: "info",
					istimeout: false,
					width: "80%",
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(uploadFileRequestFailed({ case_id: data.case_id, error: result?.data?.message }))
			yield delay(3000)
			yield put(uploadFileRequestClear(data.case_id))
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(uploadFileRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(uploadFileRequestFailed())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* getUploadFileSummarySaga(action) {
	try {
		const { ...data } = action.payload
		const result = yield call(getUploadFileSummaryService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(getUploadFileSummarySuccess(result.data)) //update store
		} else {
			yield put(getUploadFileSummaryFailed({ error: result?.data?.message }))
			yield delay(3000)
			yield put(getUploadFileSummaryClear())
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(getUploadFileSummaryFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(getUploadFileSummaryFailed())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* deleteCaseSaga(action) {
	try {
		const { ...data } = action.payload
		const result = yield call(deletCaseService, data?.case_id)

		if (result?.status === 200 && result?.data?.success === true) {
			let alert = {
				msg: "Case deleted successfully",
				class: "alert alert-success",
			}
			yield put(showAlertAction(alert))
			yield delay(1000)
			yield put(hideAlert())
			yield put(deleteCaseRequestSuccess(result.data)) //update store
			yield put(deleteCaseRequestClear())
		} else {
			let alert = {
				msg: result?.data?.message,
				class: "alert alert-danger",
			}
			yield put(showAlertAction(alert))
			yield delay(3000)
			yield put(hideAlert())
			yield put(deleteCaseRequestFailed({ error: result?.data?.message }))
			yield put(deleteCaseRequestClear())
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(deleteCaseRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(deleteCaseRequestFailed())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* extractFileSaga(action) {
	try {
		const { name, refreshCasePage, ...data } = action.payload
		const result = yield call(extractFileService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(extractFileRequestSuccess(result.data.bifrost_job)) //update store
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
					duration: 5000,
				})
			)
			yield put(extractFileRequestFailed({ case_id: data.case_id, error: result?.data?.message }))
			yield delay(3000)
			yield put(extractFileRequestClear(data.case_id))
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(extractFileRequestFailed(Messages.SERVER_ERROR))
				yield put(
					setNotification({
						data: result?.data?.message || "There was an error. Please, try again and check your connection",
						severity: "error",
						duration: 5000,
					})
				)

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(extractFileRequestClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* kbMakingTriggerSaga(action) {
	try {
		const { refreshCasePage, data } = action.payload
		const result = yield call(kbMakingService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(kbMakingTriggerRequestSuccess(result.data.bifrost_job)) //update store

			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(kbMakingTriggerRequestFailed({ case_id: data.case_id, error: result?.data?.message }))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
					duration: 5000,
				})
			)
			yield delay(3000)
			yield put(kbMakingTriggerRequestClear(data.case_id))
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(kbMakingTriggerRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(kbMakingTriggerRequestClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* pIIExtractTriggerSaga(action) {
	try {
		const { refreshCasePage, ...data } = action.payload
		const result = yield call(bifrostJobService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(PiiExtractTriggerRequestSuccess(result.data.bifrost_job))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(PiiExtractTriggerRequestFailed({ case_id: data.case_id, error: result?.data?.message }))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
					duration: 5000,
				})
			)
			yield delay(3000)
			yield put(PiiExtractTriggerRequestClear(data.case_id))
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(PiiExtractTriggerRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(PiiExtractTriggerRequestClear())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

function* revertPIIExtractSaga(action) {
	try {
		const { refreshCasePage, ...data } = action.payload
		const result = yield call(bifrostJobService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(RevertPiiExtractRequestSuccess(result?.data?.bifrost_job))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(RevertPiiExtractRequestFailed({ case_id: data.case_id, error: result?.data?.message }))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
					duration: 5000,
				})
			)
			yield delay(3000)
			yield put(RevertPiiExtractRequestClear(data.case_id))
		}
	} catch (error) {
		yield put(RevertPiiExtractRequestFailed(error))
	}
}

function* revertTextExtractSaga(action) {
	try {
		const { refreshCasePage, ...data } = action.payload
		const result = yield call(RevertTextExtractService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(RevertTextExtractRequestSuccess(result?.data?.bifrost_job))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(RevertTextExtractRequestFailed({ case_id: data.case_id, error: result?.data?.message }))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
					duration: 5000,
				})
			)
			yield delay(3000)
			yield put(RevertTextExtractRequestClear(data.case_id))
		}
	} catch (error) {
		yield put(RevertTextExtractRequestFailed(error))
	}
}

function* changeCaseModeSaga(action) {
	try {
		const { refreshCasePage, ...data } = action.payload
		const result = yield call(ChangeCaseModeService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(changeCaseModeRequestSuccess(result?.data?.bifrost_job))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(changeCaseModeRequestFailed({ case_id: data.case_id, error: result?.data?.message }))
			yield put(getCaseDetailsRequest(data.case_id))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
					duration: 5000,
				})
			)
			yield delay(3000)
			yield put(changeCaseModeRequestClear(data.case_id))
		}
	} catch (error) {
		yield put(changeCaseModeRequestFailed(error))
	}
}

function* bifrostJobTriggerSaga(action) {
	try {
		const { refreshCasePage, ...data } = action.payload
		const result = yield call(bifrostJobService, data)

		if (result?.status === 200 && result?.data?.success === true) {
			yield put(postBifrostJobRequestSuccess(result.data.bifrost_job))
			yield put(
				setNotification({
					data: result?.data?.message,
					severity: "success",
					duration: 5000,
				})
			)
			if (refreshCasePage) {
				yield put(getCaseDetailsRequest(data.case_id))
			}
		} else {
			yield put(postBifrostJobRequestFailed({ case_id: data?.case_id, error: result?.data?.message }))
			yield put(
				setNotification({
					data: result?.data?.message || "There was an error. Please, try again and check your connection",
					severity: "error",
					duration: 5000,
				})
			)
			yield delay(3000)
			yield put(postBifrostJobRequestReset())
		}
	} catch (error) {
		try {
			if (axiosClient.isCancel(error)) {
			} else {
				if (error.response.status === 403) {
					clearLocalStorage()
					yield put(clearMultibase())
					yield put(logoutUser())
					return
				}

				yield put(postBifrostJobRequestFailed(Messages.SERVER_ERROR))

				let alert = {
					msg: Messages.SERVER_ERROR,
					class: "alert alert-danger",
				}
				yield put(showAlertAction(alert))

				yield delay(3000) //After 3sec message disappear
				yield put(postBifrostJobRequestReset())
				yield put(hideAlert())
			}
		} catch (e) {
			console.log(e)
		}
	}
}

export default function* bifrostCaseSaga() {
	yield takeLatest(UPLOAD_FILE_REQUEST, uploadFileSaga)
	yield takeLatest(GET_UPLOAD_FILE_SUMMARY_REQUEST, getUploadFileSummarySaga)
	yield takeLatest(DELETE_CASE_REQUEST, deleteCaseSaga)
	yield takeLatest(EXTRACT_FILE_REQUEST, extractFileSaga)
	yield takeLatest(KB_MAKING_TRIGGER_REQUEST, kbMakingTriggerSaga)
	yield takeLatest(PII_EXTRACT_TRIGGER_REQUEST, pIIExtractTriggerSaga)
	yield takeLatest(REVERT_PII_EXTRACT_REQUEST, revertPIIExtractSaga)
	yield takeLatest(REVERT_TEXT_EXTRACT_REQUEST, revertTextExtractSaga)
	yield takeLatest(CHANGE_CASE_MODE_REQUEST, changeCaseModeSaga)
	yield takeLatest(POST_BIFROST_JOB_REQUEST, bifrostJobTriggerSaga)
}
